export default function Container({ children }: { children: React.ReactNode }) {
  return <div className="md:w-[80%] sm:w-full md:mx-auto">{children}</div>;
}
